import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import { Container, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import NewsModel from '../../models/news.model';
import pageMeta from '../../models/pagemeta.model';
import { useEffect } from 'react';
import Preloader from '../../components/PreLoader';
import NoticeCard from '../../components/NoticeCard';
import { lang } from '../../config/app.config';
import Paginate from '../../components/pagination';
import { fetchNotices } from '../../services/notice.service';
// import translate from '../../translation.json';
import { TranslationState } from '../../store/ActionReducers/translation.actionreducer';
import InfoCard from '../../components/infoCard';
import { useParams } from 'react-router';


interface state {
  notice: {
    notices: Array<NewsModel>,
    loading: boolean,
    meta: pageMeta
  }
}

interface params {
  dist_slug: string
}

const Notice: React.FC = () => {

  // redux store
  const dispatch = useDispatch();

  const state = useSelector((state: state) => {
    const { notice } = state;
    return notice;
  });
  const { loading: noticeLoading, notices, meta } = state;
  const { dist_slug } = useParams<params>();


  //end redux store

  //load news
  const loadNotice = (page: number = 1) => {
    dispatch(fetchNotices(page, dist_slug));
  }


  useEffect(() => {
    loadNotice();
  }, [dispatch]) //eslint-disable-line

  const stateTr = useSelector((state: { translation: TranslationState }) => state.translation);

  return (
    <>
      {noticeLoading ? <Preloader /> :
        <>
          <Breadcrumb routes={[{ title: stateTr.translation ? stateTr.translation.notice[lang === 'np' ? "value_np" : "value_en"] : "" }]} slug="notice" />
          <div className="text-center curveBackground">
            <h3 className="ecn-title-inv text-26">{stateTr.translation ? stateTr.translation.notice[lang === 'np' ? "value_np" : "value_en"] : ""}</h3>
          </div>
          <div className="section-padding-2">
            <Container maxWidth="lg">
              <Grid container spacing={3} className="justify-content-center">
                {notices && notices.length ?
                  notices.map((n: any) => (
                    <Grid item xs={12} md={10} key={n.id}>
                      <InfoCard data={n} key={n.id} />
                    </Grid>
                  )) :
                  <Grid item xs={12}>
                    <h3 className="text-center section-break-4 text-28-primary">
                      Sorry no Notices found!!
                    </h3>
                  </Grid>
                }
              </Grid>
              <div className="section-break-2 text-center">
                <Paginate meta={meta} paginate={loadNotice} />
              </div>
            </Container>
          </div>
        </>
      }
    </>
  );
}

export default Notice;